'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dScope from "./presto.types$-Dashboard-Scope.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardScope$$anon$9(_$ordinal$20, \u03b4name$20, outer) {
  this.cz2 = 0;
  this.aa3 = null;
  this.cz2 = _$ordinal$20;
  this.aa3 = \u03b4name$20;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$DashboardScope$$anon$9 as $c_Lpresto_types$DashboardScope$$anon$9 };
$p = $c_Lpresto_types$DashboardScope$$anon$9.prototype = new $j_presto$002etypes$0024$002dDashboard$002dScope.$h_Lpresto_types$DashboardScope();
$p.constructor = $c_Lpresto_types$DashboardScope$$anon$9;
/** @constructor */
function $h_Lpresto_types$DashboardScope$$anon$9() {
}
export { $h_Lpresto_types$DashboardScope$$anon$9 as $h_Lpresto_types$DashboardScope$$anon$9 };
$h_Lpresto_types$DashboardScope$$anon$9.prototype = $p;
$p.r = (function() {
  return 0;
});
$p.j = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.s = (function() {
  return this.aa3;
});
$p.l = (function() {
  return this.aa3;
});
var $d_Lpresto_types$DashboardScope$$anon$9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardScope$$anon$9, "presto.types$DashboardScope$$anon$9", ({
  Zt: 1,
  Zr: 1,
  b: 1,
  c: 1,
  a: 1,
  q: 1,
  s: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_types$DashboardScope$$anon$9 as $d_Lpresto_types$DashboardScope$$anon$9 };
//# sourceMappingURL=presto.types$-Dashboard-Scope$$anon$9.js.map
